<div *ngIf="showLoadingBar$ | async" class="section-container">
  <div
    *ngFor="let loaded of loadedFrames$ | async; trackBy: trackByIndex"
    [class.loaded]="loaded"
  ></div>
</div>
